import React from "react";

function Header() {
  return (
    <header>
      <img src="https://static.vecteezy.com/system/resources/previews/003/026/270/large_2x/hq-logo-monogram-modern-design-template-free-vector.jpg" alt="Smily Face" />
      <p>HQ MEME MAKER</p>
    </header>
  );
}

export default Header;
